import type { WheelSegmentV1 } from "../../types/wheel";

/**
 * Arc center angles (degrees from top, clockwise) for a **spinable** segment list.
 * Indices must match `getSpinableSegments(...)` order — same as `resultIndex` from the API.
 */
export function segmentCenterDegreesFromTop(segments: WheelSegmentV1[]): number[] {
  const total = segments.reduce((s, x) => s + x.weight, 0);
  if (total <= 0) return [];
  let acc = 0;
  const centers: number[] = [];
  for (const seg of segments) {
    const span = (seg.weight / total) * 360;
    centers.push(acc + span / 2);
    acc += span;
  }
  return centers;
}

export function polarToXY(cx: number, cy: number, r: number, degFromTop: number): [number, number] {
  const svgDeg = -90 + degFromTop;
  const rad = (svgDeg * Math.PI) / 180;
  return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)];
}
